import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

type GetDraftV2Params = paths['/v2/drafts/{draftUuid}']['get']['parameters']['path'];

export type DraftV2 = NonNullable<
  paths['/v2/drafts/{draftUuid}']['get']['responses'][200]['content']['application/json']['data']
>;

async function getDraftV2({ draftUuid }: GetDraftV2Params) {
  const { data } = await fetchClient.GET('/v2/drafts/{draftUuid}', {
    params: {
      path: { draftUuid },
    },
  });

  return data?.data;
}

/**
 * Query options for fetching a single draft.
 *
 * Cache Key: ['draftsV2', userId, draftUuid]
 *
 * On delete:
 * 1. Remove this draft from cache
 */
export function getDraftV2QueryOptions({
  draftUuid,
  userId,
}: GetDraftV2Params & { userId: string | undefined }) {
  return queryOptions({
    queryKey: ['draftsV2', userId, draftUuid],
    queryFn: () => getDraftV2({ draftUuid }),
    staleTime: ONE_MINUTE,
    gcTime: ONE_MINUTE,
  });
}
